// extracted by mini-css-extract-plugin
export var addToCartButton = "_qv-b";
export var arrowButtonContainer = "_qv-9";
export var arrowButtonIcon = "_qv-a";
export var carouselArrowButton = "_qv-6";
export var carouselElementContainer = "_qv-1";
export var left = "_qv-7";
export var productDisplayCarouselContainer = "_qv-0";
export var productTileContainer = "_qv-2";
export var productTileImage = "_qv-4";
export var productTileImageContainer = "_qv-3";
export var productTileTitle = "_qv-5";
export var right = "_qv-8";
export var sliderOverflow = "_qv-c";